<template>
  <div class="rule-of-warning wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">预警规则配置</label>
        <Row>
          <Col span="12">
            <div class="content-left">
              <strong>论文评审周期配置</strong>
              <Form class="left-form" >
                <FormItem v-for="(item,index) in leftForm.leftList" :key="index" style="min-width:220px;">
                  <Row>
                    <Col span="6" style="min-width:120px;"><label>{{ item[1] }}</label></Col>
                    <Col span="4" style="min-width:60px;">
                      <Input placeholder="必填项" v-model="leftForm.schoolAuditPeriodConfigEntity[item[0]] "/>
                    </Col>
                    <Col span="4" style="text-align: right;min-width: 40px;" >
                      <label>工作日</label>
                    </Col>
                  </Row>
                </FormItem>
              </Form>
              <Button type="primary" @click="saveLeftConfig">保存配置</Button>
            </div>
          </Col>
          <Col span="12">
            <div class="content-right">
              <strong>评审预警提醒配置</strong>
              <Form class="right-form">
                <FormItem v-for="(item,index) in rightForm.rightList" :key="index" style="min-width:220px;">
                  <Row>
                    <Col span="6" style="min-width: 140px;"><label>{{ item[1] }}</label></Col>
                    <Col span="4" style="min-width: 60px;">
                      <Input placeholder="必填项" v-model="rightForm.schoolAlertConfigEntity[item[0]]"/>
                    </Col>
                    <Col span="4" style="text-align: right;min-width:40px;">
                      <label>工作日</label>
                    </Col>
                  </Row>
                </FormItem>
              </Form>
              <Button type="primary" @click="saveRightConfig">保存配置</Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
// 预警规则
export default {
  name: 'ruleOfWarning',
  data () {
    return {
      leftForm: {
        // 左边列表
        leftList: [
          ['masterFirstAuditDays', '硕士论文初评：'],
          ['masterSecondAuditDays', '硕士论文复评：'],
          ['masterAddAduitDays', '硕士论文增评：'],
          ['doctorFirstAuditDays', '博士论文初评：'],
          ['doctorSecondAuditDays', '博士论文复评：'],
          ['doctorAddAuditDays', '博士论文增评：']
        ],
        // 论文评审周期配置的实体
        schoolAuditPeriodConfigEntity: {
          masterFirstAuditDays: '',
          masterSecondAuditDays: '',
          masterAddAduitDays: '',
          doctorFirstAuditDays: '',
          doctorSecondAuditDays: '',
          doctorAddAuditDays: ''
        }
      },
      rightForm: {
        // 右边列表
        rightList: [
          ['masterFirstAuditDays', '硕士论文初评剩余：'],
          ['masterSecondAuditDays', '硕士论文复评剩余：'],
          ['masterAddAduitDays', '硕士论文增评剩余：'],
          ['doctorFirstAuditDays', '博士论文初评剩余：'],
          ['doctorSecondAuditDays', '博士论文复评剩余：'],
          ['doctorAddAuditDays', '博士论文增评剩余：']
        ],
        // 评审预警提醒配置的实体
        schoolAlertConfigEntity: {
          masterFirstAuditDays: '',
          masterSecondAuditDays: '',
          masterAddAduitDays: '',
          doctorFirstAuditDays: '',
          doctorSecondAuditDays: '',
          doctorAddAuditDays: ''
        }
      }
    }
  },
  created () {
    this.getSchoolAuditPeriodConfig();
    this.getSchoolAlertConfigInfo();
  },
  activated () {
    this.getSchoolAuditPeriodConfig();
    this.getSchoolAlertConfigInfo();
  },
  methods: {
    // 评审周期查询
    getSchoolAuditPeriodConfig: function () {
      this.post('/school/schoolAuditPeriodConfig/getSchoolAuditPeriodConfig', {}).then(res => {
        if (res.data !== undefined) {
          this.leftForm.schoolAuditPeriodConfigEntity = res.data;
        }
      })
    },
    // 评审预警提醒查询
    getSchoolAlertConfigInfo: function () {
      this.post('/school/schoolAlertConfig/getSchoolAlertConfigInfo', {}).then(res => {
        if (res.data !== undefined) {
          this.rightForm.schoolAlertConfigEntity = res.data;
        }
      })
    },
    // 保存论文评审周期配置
    saveLeftConfig () {
      let params = this.leftForm.schoolAuditPeriodConfigEntity;
      this.post('/school/schoolAuditPeriodConfig/saveOrUpdate', params).then(res => {
        if (res.code === 200) {
          this.$Message.success('论文评审周期配置保存成功!');
        }
      })
    },
    // 保存预警提醒配置
    saveRightConfig () {
      let params = this.rightForm.schoolAlertConfigEntity;
      this.post('/school/schoolAlertConfig/saveOrUpdate', params).then(res => {
        if (res.code === 200) {
          this.$Message.success('预警提醒配置保存成功!');
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .rule-of-warning{
    .content-left{
      border-right: 1px solid #dddddd;
      margin-left: 20%;
    }
    .content-right{
      margin-left: 20%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/ruleOfWarning.vue